import { isPerProductFieldType } from './is-per-product-field-type.js';
export function isPerProductFieldId(fieldId, fields) {
    const field = fields.find((candidate) => candidate.id === fieldId);
    return field !== undefined && isPerProductFieldType(field.type);
}
//# sourceMappingURL=is-per-product-field-id.js.map